export const projectHotelQueryKeys = {
  all: () => ['projectHotels'] as const,
  list: (projectContainerId: number | undefined) => ['projectHotels', projectContainerId] as const,
  assessmentContext: (projectContainerId: number | undefined) =>
    ['projectHotels', projectContainerId, 'assessmentContext'] as const,
  countries: () => ['projectHotels', 'countries'] as const,
  mapCities: (projectContainerId: number | undefined, provinceId: number | undefined) =>
    ['projectHotels', projectContainerId, 'mapCities', provinceId] as const,
  mapHotels: (projectContainerId: number | undefined, cityId: number | undefined) =>
    ['projectHotels', projectContainerId, 'mapHotels', cityId] as const,
  availableRates: (projectContainerId: number | undefined, projectHotelId: number | undefined) =>
    ['projectHotels', projectContainerId, projectHotelId, 'availableRates'] as const,
  contracts: (projectContainerId: number | undefined, projectHotelId: number | undefined) =>
    ['projectHotels', projectContainerId, projectHotelId, 'contracts'] as const
};
